import React from 'react';
import { Navbar } from '../components/layout/navbar';
import { HeroSection } from '../components/sections/heroSection';
import { IndividualSection } from '../components/sections/individualSection';
import { BusinessSection } from '../components/sections/businessSection';
import { FeaturesSection } from '../components/sections/feturesSection';
import { TestimonialsSection } from '../components/sections/testimonialsSection';
import { ContactSection } from '../components/sections/contactSection';
import { Footer } from '../components/layout/Footer';
import { FloatingAssistant } from '../components/layout/floatingAssistant';
import { PricingSection } from '../components/sections/pricingSection';
import { ExtensionInstallSection } from '../components/sections/extensionInstallSection';


// Types


// Context pour le thème

const HomePage: React.FC = () => {
  return (
      <div className="bg-white dark:bg-gray-900 transition-colors duration-300">
        <Navbar />
        <HeroSection />
        <IndividualSection />
        <BusinessSection showButton/>
        <FeaturesSection />
        <PricingSection />
        <TestimonialsSection />
        <ContactSection />
        <Footer />
        <FloatingAssistant />
      </div>
  );
}   
export default HomePage;
